<template>
  <!--  gradient="to right, rgba(5, 11, 31, .4), rgba(5, 11, 31, .6)"  -->
  <!--   gradient="to right, rgba(255, 255, 255, .1), rgba(255, 255, 255, .9)"  -->
  <!--  gradient="to right, rgba(5, 11, 31, .1), rgba(5, 11, 31, .6)"-->
  <v-img
      :min-height="minHeight"
      :src="require('@/assets/kilbi-bg5.jpg')"
      class="white--text"
      gradient="to right, rgba(255, 255, 255, .0), rgba(0, 0, 0, .15)"
  >
    <v-container class="fill-height1 mt-10">
      <v-row class="text-left ma-5" align="" justify="">
        <v-row class="text-left" align="" justify="center">
          <v-col cols="12" sm="12" lg="10">
            <div class="mb-10" :class="fontSize" style="text-shadow: 0px 0px 10px darkslategray">
              <i>{{ $t('index.title') }}</i>
            </div>
            <div class="display-1 mb-10 font-italic" style="text-shadow: 0px 0px 10px darkslategray">
              {{ $t('index.description') }}
            </div>
          </v-col>
        </v-row>
        <v-row class="text-center mt-5" align="" justify="center">
          <v-col cols="12" sm="6" md="6" lg="5" xl="5" class="text-sm-left" order-sm="2">
            <img width="" style="max-width: 100%" src="img/home-songgl-preview-2024.png" class="previewSonggl">
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="5" xl="5" class="shrink" order-sm="1">
            <div class="mb-10 ">
              <div class="text-left" justify="center">
                <div>
                  <div class="headline mb-4 font-italic" style="text-shadow: 0px 0px 10px darkslategray">
                    {{ $t('index.headline') }}
                  </div>
                  <v-row justify="" align="center">
                    <v-list-item dark >
                      <v-list-item-avatar color="primary" size="48" class="mb-2">
                        <span class="buttonColor--text headline">1</span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline text-wrap " style="text-shadow: 0px 0px 10px darkslategray">{{ $t('index.step1') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item dark>
                      <v-list-item-avatar color="primary" size="48" class="mb-2">
                        <span class="buttonColor--text headline">2</span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline text-wrap" style="text-shadow: 0px 0px 10px darkslategray">{{ $t('index.step2') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item dark>
                      <v-list-item-avatar color="primary" size="48" class="mb-2 " >
                        <span class="buttonColor--text headline">3</span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline text-wrap" style="text-shadow: 0px 0px 10px darkslategray">{{ $t('index.step3') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12" class="text-left" style="text-shadow: 0px 0px 10px darkslategray">
                      <div class="my-10">
                        <v-btn rounded class="secondary buttonColor--text" x-large @click="$router.push('create')">{{ $t('start') }}
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
  </v-img>
</template>

<script>

export default {
  name: 'Home',
  components: {},
  data: () => ({}),
  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '100vh'

      return `calc(${height} - ${this.$vuetify.application.top}px - ${this.$vuetify.application.insetFooter}px)`
    },
    fontSize() {
      return this.$vuetify.breakpoint.mdAndUp ? 'display-3' : 'display-2'
    },
    colSize() {
      return this.$vuetify.breakpoint.xs ? 10 : 10
    }
  },
  methods: {
  }
}
</script>
